
export const GET_POSITIONS_BEGIN = "GET_POSITIONS_BEGIN";
export const GET_POSITIONS_SUCCESS = "GET_POSITIONS_SUCCESS";
export const GET_POSITIONS_ERROR = "GET_POSITIONS_ERROR";

export const DELETE_POSITIONS_BEGIN = "DELETE_POSITIONS_BEGIN";
export const DELETE_POSITIONS_SUCCESS = "DELETE_POSITIONS_SUCCESS";
export const DELETE_POSITIONS_ERROR = "DELETE_POSITIONS_ERROR";

export const CREATE_POSITION_BEGIN = 'CREATE_POSITION_BEGIN'
export const CREATE_POSITION_SUCCESS = 'CREATE_POSITION_SUCCESS'
export const CREATE_POSITION_ERROR = 'CREATE_POSITION_ERROR'

export const UPDATE_POSITION_BEGIN = 'UPDATE_POSITION_BEGIN'
export const UPDATE_POSITION_SUCCESS = 'UPDATE_POSITION_SUCCESS'
export const UPDATE_POSITION_ERROR = 'UPDATE_POSITION_ERROR'

export const ADD_USER_POSITION_BEGIN = 'ADD_USER_POSITION_BEGIN'
export const ADD_USER_POSITION_SUCCESS = 'ADD_USER_POSITION_SUCCESS'
export const ADD_USER_POSITION_ERROR = 'ADD_USER_POSITION_ERROR'

export const DELETE_USER_POSITION_BEGIN = 'DELETE_USER_POSITION_BEGIN'
export const DELETE_USER_POSITION_SUCCESS = 'DELETE_USER_POSITION_SUCCESS'
export const DELETE_USER_POSITION_ERROR = 'DELETE_USER_POSITION_ERROR'

export const CLEAR_NEW_POSITION_STATE = 'CLEAR_NEW_POSITION_STATE'
